import { inject } from "@angular/core";
import { Auth, authState } from "@angular/fire/auth";
import { Database, objectVal, ref } from "@angular/fire/database";
import { CanActivateFn, Router } from "@angular/router";
import { Provider } from "@lfg-interface/provider.interfaces";
import { map, of, switchMap, take } from "rxjs";

export const customRegisterGuard: CanActivateFn = (route, state) => {
  const afAuth = inject(Auth);
  const db = inject(Database);
  const router = inject(Router);

  return authState(afAuth).pipe(
    take(1),
    switchMap((user) => {
      if (!user) {
        return of(router.createUrlTree(['/sign-in']));
      }
      const refDb = ref(db, `CarFinderGeniePlatform/providers/${user.uid}/`);
      return objectVal<Provider | null>(refDb).pipe(
        take(1),
        map((response: Provider | null) => {
          const isVerified = user.emailVerified;
          const isRegistered = response?.user_profile?.register_completed === true;

          // if (isVerified && isRegistered) {
          if (isRegistered) {
            // Evita redirigir si ya estamos en /dashboard
            if (state.url !== '/dashboard') {
              return router.createUrlTree(['/dashboard']);
            } else {
              return true;
            }
          }

          // Si no está registrado, puede acceder a la ruta protegida por este guard
          return true;
        })
      );
    })
  );
};
